import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import maisInternetLogo from './img/maisInternetLogo.png';
import skyLogo from './img/sky-logo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isCPFActive, setIsCPFActive] = useState(false);
  const [isPasswordActive, setIsPasswordActive] = useState(false);

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  const isFormValid = () => {
    return username.trim() !== '' && password.trim() !== '';
  };

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <>
        <div className="logos-container" ref={nodeRef}>
          <img src={skyLogo} alt="Sky Logo" className="sky-logo" />
          <img src={maisInternetLogo} alt="Mais Internet Logo" className="mais-internet-logo" />
        </div>
        <div className="login-maisinternet-container">
          <div className="login-maisinternet-body">
            <h3>{translate("LoginTitle")}</h3>
            <Form onSubmit={event => onSubmit(event)}>
              <Col sm="12" xs="12" md="12" style={{ padding: '0px' }}>
                <div className={`floating-label-group ${isCPFActive || username ? 'active' : ''}`}>
                  <Input
                    className="input-maisinternet floating-label-input"
                    disabled={onLogin}
                    required={true}
                    tabIndex={1}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="username"
                    value={username}
                    onFocus={() => setIsCPFActive(true)}
                    onBlur={() => setIsCPFActive(false)}
                    onChange={e => setUsername(e.target.value)}
                  />
                  <label className="floating-label">{translate("DocumentLabel")}</label>
                </div>
              </Col>
              <Col sm="12" xs="12" md="12" style={{ padding: '0px' }}>
                <div className={`floating-label-group ${isPasswordActive || password ? 'active' : ''}`}>
                  <Input
                    className="input-maisinternet floating-label-input"
                    required={true}
                    disabled={onLogin}
                    tabIndex={2}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    value={password}
                    onFocus={() => setIsPasswordActive(true)}
                    onBlur={() => setIsPasswordActive(false)}
                    onChange={e => setPassword(e.target.value)}
                  />
                  <label className="floating-label">{translate("PasswordLabel")}</label>
                </div>
              </Col>
              {!onLogin ?
                <div className="row maisinternet-btns-row">
                  <div className="col-xs-12 col-md-12 col-lg-12">
                    <div>
                      <button
                        block={!parameters.failureRedirect}
                        tabIndex={1}
                        className="enter-maisinternet"
                        type="submit"
                        name="submit"
                        disabled={!isFormValid() || !props.turnstileSuccess}
                      >
                        {translate("ButtonEnter")}
                      </button>
                    </div>
                  </div>
                </div>
                :
                <Progress animated color="danger" value={100} />
              }
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                  {error.message}
                </Alert>
              </div>
              <div className="bottom-links">
                <a href="https://maisinternet.net.br/sva/trocar-senha.html">
                  {translate("ForgotPassword")}
                </a>
                <a href="https://maisinternet.net.br/sva/primeiro-acesso.html">{translate("FirstAccess")}</a>
              </div>
            </Form>
          </div>
          <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
        </div>
      </>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
